import { $authHost, $host } from "./index";
import { jwtDecode } from "jwt-decode";

export const registration = async (email, password, name, role = 'USER', login) => {
  const { data } = await $host.post("/api/user/registration", {
    email,
    password,
    name,
    role: role, //TODO: Поменять роль
    login
  });
  localStorage.setItem("token", data.token);
  return jwtDecode(data.token);
};

export const edit = async (id, email, password, name, role) => {
  let toSend = {
    role,
    name
  };
  if(password && password !== ''){
    toSend.password = password;
  }
  const { data } = await $host.put("/api/user/" + id, toSend);
  return data;
};

export const login = async (login, password) => {
  const { data } = await $host.post("/api/user/login", { login, password });
  localStorage.setItem("token", data.token);
  return jwtDecode(data.token);
};

export const check = async () => {
  const { data } = await $authHost.get("/api/user/auth");
  localStorage.setItem("token", data.token);
  return jwtDecode(data.token);
};

export const getAll = async () => {
  const { data } = await $authHost.get("/api/user/");
  return data;
};

export const deleteUser = async (id) => {
  const { data } = await $authHost.delete("/api/user/" + id);
  return data;
};
